module.exports = {
    props: [
        'user', 'teams', 'currentTeam',
        'unreadAnnouncementsCount', 'unreadNotificationsCount'
    ],

    data() {
      return {
        toggle: {
          reputation: false,
          surveys: false,
          cases: false,
        }
      }
    },

    computed:{
        notificationsCount(){
            return this.unreadAnnouncementsCount + this.unreadNotificationsCount;
        },
        currentTeamPhoto(){
            return this.currentTeam?.photo_url?.endsWith('hotel-icon.ico')
              ? '/assets/img/1.0/hotel.png'
              : this.currentTeam.photo_url;
        }
    },


    methods: {
         /**
          * Show the user's notifications.
          */
         showNotifications() {
            Bus.$emit('showNotifications');
        },


        /**
         * Show the customer support e-mail form.
         */
        showSupportForm() {
            Bus.$emit('showSupportForm');
        }
    }
};
